module.exports = __webpack_public_path__ + "static/media/isf-hero.eee87b7a.png";